export default __webpack_public_path__ + "static/media/face_1_29.b95fce58.png";